import BaseProxy from './Proxy';

export default class BarringProfileFactoringProxy extends BaseProxy {
  constructor(parameters = {}) {
    super('api/barring/profile/factoring', parameters);
  }

  status() {
    return this.submit('get', `${this.endpoint}/status`);
  }

  edit() {
    return this.submit('get', `${this.endpoint}/edit`);
  }

  newProfileTypePartners() {
    return this.submit('get', `${this.endpoint}/new/partners`);
  }

  newProfileTypeCategories() {
    return this.submit('get', `${this.endpoint}/new/categories`);
  }

  write(items, isProfileTypeCategories, pin) {
    return this.submit('post', `${this.endpoint}/write`, { items, isProfileTypeCategories, pin });
  }
}
